import IconButton from "../IconButton"
import { StyledTutorialModalControls } from "./TutorialModalControls.styled"

export const TutorialModalControls = ({step, nextButtonText, onNext, onBack }) => {
  return (
    <StyledTutorialModalControls>
      <div className="btn-wrap">
        {step > 0 && <IconButton onClick={onBack}>Back</IconButton>}
      </div>
      <div className="btn-wrap">
        <IconButton onClick={onNext}>{nextButtonText}</IconButton>
      </div>
    </StyledTutorialModalControls>
  )
}